import type { PageBlock } from '../../../types'
import { HeroPreview } from './previews/HeroPreview'
import { ProductOfferPreview } from './previews/ProductOfferPreview'
import { CtaPreview } from './previews/CtaPreview'
import { DiscountBadgePreview } from './previews/DiscountBadgePreview'
import { TimerPreview } from './previews/TimerPreview'
import { TestimonialPreview } from './previews/TestimonialPreview'
import { TextPreview } from './previews/TextPreview'
import { ImageGalleryPreview } from './previews/ImageGalleryPreview'
import { FeatureListPreview } from './previews/FeatureListPreview'
import { VideoEmbedPreview } from './previews/VideoEmbedPreview'
import { ImagePreview } from './previews/ImagePreview'
import { DividerPreview } from './previews/DividerPreview'
import { CountdownPreview } from './previews/CountdownPreview'

interface BlockPreviewProps {
  block: PageBlock
}

export function BlockPreview({ block }: BlockPreviewProps) {
  const p = block.props

  switch (block.type) {
    case 'hero':
      return <HeroPreview props={p} />
    case 'product-offer':
      return <ProductOfferPreview props={p} />
    case 'product-gallery':
      return <ImageGalleryPreview props={p} />
    case 'product-specs':
      return <FeatureListPreview props={p} />
    case 'reviews-widget':
      return <TestimonialPreview props={p} />
    case 'cta-section':
      return <CtaPreview props={p} />
    case 'cta':
      return <CtaPreview props={p} />
    case 'discount-badge':
      return <DiscountBadgePreview props={p} />
    case 'timer':
      return <TimerPreview props={p} />
    case 'countdown':
      return <CountdownPreview props={p} />
    case 'testimonial':
      return <TestimonialPreview props={p} />
    case 'text':
      return <TextPreview props={p} />
    case 'image':
      return <ImagePreview props={p} />
    case 'image-gallery':
      return <ImageGalleryPreview props={p} />
    case 'feature-list':
      return <FeatureListPreview props={p} />
    case 'video-embed':
      return <VideoEmbedPreview props={p} />
    case 'divider':
      return <DividerPreview props={p} />
    default:
      return <p className="text-tf-text-muted text-sm">Unknown block type: {block.type}</p>
  }
}
